<div
  (click)="triggerFancybox()"
  class="attachment__file d-flex flex-column justify-content-between align-items-center mr-2 cursor-pointer"
>
  <img draggable="false" class="attachment__file-images" src="assets/img/ic-image.svg" alt="Image" />
  <span [innerHTML]="'showMore' | translate"> </span>
</div>
